var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 7C8.375 7 7.03125 8.34375 7.03125 10C7.03125 11.6563 8.375 13 10.0312 13C11.6875 13 13.0312 11.6563 13.0312 10C13.0312 8.34375 11.6875 7 10.0312 7ZM10.0312 11.75C9.0625 11.75 8.28125 10.9688 8.28125 10C8.28125 9.03125 9.0625 8.25 10.0312 8.25C11 8.25 11.7812 9.03125 11.7812 10C11.7812 10.9688 11 11.75 10.0312 11.75Z",
    fill: "#D33030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2813 6.31246C13.75 5.68746 12.875 6.59371 13.4063 7.18746C14.7813 8.78121 14.7813 11.2187 13.4063 12.8125C12.875 13.4062 13.75 14.3125 14.2813 13.6875C16.125 11.5625 16.125 8.43746 14.2813 6.31246Z",
    fill: "#D33030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 3.8757C15.5938 3.28195 14.7188 4.15695 15.25 4.7507C17.8438 7.71945 17.8438 12.2507 15.25 15.2195C14.7188 15.8132 15.5938 16.7195 16.125 16.0945C17.5938 14.4382 18.4375 12.2507 18.4375 10.0007C18.4375 7.7507 17.5938 5.59445 16.125 3.8757Z",
    fill: "#D33030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 7.18746C7.15625 6.59371 6.28125 5.68746 5.75 6.31246C3.90625 8.46871 3.90625 11.5625 5.75 13.7187C6.28125 14.3437 7.15625 13.4375 6.625 12.8437C5.21875 11.2187 5.21875 8.78121 6.625 7.18746Z",
    fill: "#D33030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 4.74996C5.3125 4.15621 4.4375 3.24996 3.90625 3.87496C2.40625 5.56246 1.5625 7.74996 1.5625 9.99996C1.5625 12.25 2.40625 14.4062 3.90625 16.125C4.4375 16.7187 5.3125 15.8437 4.78125 15.25C2.1875 12.2812 2.1875 7.74996 4.78125 4.74996Z",
    fill: "#D33030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.74cd341d9d05d648467ee142f220f04a.svg";
export { ForwardRef as ReactComponent };